var map = {
	"./1_Felicitas Ernst_Amazon_advertising_Publicidad_MG_5282.webp": "./src/img/brands/amazon/1_Felicitas Ernst_Amazon_advertising_Publicidad_MG_5282.webp",
	"./Felicitas Ernst_Amazon_advertising_Publicidad1_MG_5350.webp": "./src/img/brands/amazon/Felicitas Ernst_Amazon_advertising_Publicidad1_MG_5350.webp",
	"./Felicitas Ernst_Amazon_advertising_Publicidad_MG_5147.webp": "./src/img/brands/amazon/Felicitas Ernst_Amazon_advertising_Publicidad_MG_5147.webp",
	"./Felicitas Ernst_Amazon_advertising_Publicidad_MG_5183.webp": "./src/img/brands/amazon/Felicitas Ernst_Amazon_advertising_Publicidad_MG_5183.webp",
	"./Felicitas Ernst_Amazon_advertising_Publicidad_MG_5399.webp": "./src/img/brands/amazon/Felicitas Ernst_Amazon_advertising_Publicidad_MG_5399.webp",
	"./Felicitas Ernst_Amazon_advertising_Publicidad_MG_5430.webp": "./src/img/brands/amazon/Felicitas Ernst_Amazon_advertising_Publicidad_MG_5430.webp",
	"./Felicitas Ernst_Amazon_advertising_Publicidad_MG_5461.webp": "./src/img/brands/amazon/Felicitas Ernst_Amazon_advertising_Publicidad_MG_5461.webp",
	"./Felicitas Ernst_Amazon_advertising_Publicidad_MG_5535.webp": "./src/img/brands/amazon/Felicitas Ernst_Amazon_advertising_Publicidad_MG_5535.webp",
	"./Felicitas Ernst_Amazon_advertising_Publicidad_MG_5701.webp": "./src/img/brands/amazon/Felicitas Ernst_Amazon_advertising_Publicidad_MG_5701.webp",
	"./Felicitas Ernst_Amazon_advertising_Publicidad_MG_5736.webp": "./src/img/brands/amazon/Felicitas Ernst_Amazon_advertising_Publicidad_MG_5736.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img/brands/amazon sync \\.(webp%7Cjpg%7Cjpeg%7Cpng)$";